import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Calculator from '@components/Utilities/Calculator';
interface ModalAddShippingCostProps {
    modalAddShippingCost: OpenModalHookType;
    onAddShippingCost: (value: number) => void;
}
export const ModalAddShippingCost: React.FunctionComponent<ModalAddShippingCostProps> = (props: any) => {
    const { modalAddShippingCost, onAddShippingCost } = props;
    const [amount, setAmount] = useState<number>(0);
    const handleClose = () => {
        setAmount(0);
        modalAddShippingCost.toggle();
    };

    const onDone = () => {
        handleClose();
        onAddShippingCost(amount);
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalAddShippingCost.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-add-shipping-cost-title"
            aria-describedby="modal-add-shipping-cost-description"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="modal-add-shipping-cost-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight={600}>
                        Agregar envio
                    </Typography>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack alignItems="center" spacing={2}>
                    <Calculator onChangeValue={setAmount} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button disabled={amount === 0} fullWidth onClick={onDone} color="success" variant="contained">
                    Agregar monto de envio
                </Button>
            </DialogActions>
        </Dialog>
    );
};
